import { createReducer } from '@reduxjs/toolkit'

import { InternalThreadsActions } from './actions'
import type { Thread } from './types'

export const threadsReducer = createReducer<Thread[]>([], (builder) => {
  builder
    .addCase(InternalThreadsActions.set, (_, { payload }) => payload)
    .addCase(InternalThreadsActions.add, (state, { payload }) => [
      ...state,
      payload,
    ])
    .addCase(InternalThreadsActions.delete, (state, { payload: { id } }) =>
      state.filter((t) => t.uuid !== id)
    )
    .addCase(InternalThreadsActions.update, (state, { payload }) =>
      state.map((t) => {
        if (t.uuid !== payload.uuid) {
          return t
        }
        return {
          ...t,
          ...payload,
        }
      })
    )
})
